import { IS_MOCK_MODE } from 'src/constants/featureFlag'
import { SERVER_URL } from 'src/constants/serverUrl'
import { requestPut } from 'src/legacy_modules/server/request'

export const submitTemplateDisable = async ({
  trialUid,
  templateUid,
}: {
  trialUid: string
  templateUid: string
}): Promise<{}> => {
  if (IS_MOCK_MODE) {
    return {}
  }

  await requestPut<{}>({
    url: `${SERVER_URL}/trials/${trialUid}/templates/${templateUid}/disable`,
    params: {},
  })

  return {}
}
